import { createColumnHelper } from '@tanstack/react-table';
import { Translation } from 'react-i18next';

import { ActionButtonWrapper } from '../components/action-buttons';
import { IFermentation } from '../types/fermentation';

const columnHelper = createColumnHelper<IFermentation>();

export const fermentationColumns = [
  columnHelper.accessor('name', {
    header: () => <Translation>{(t) => <>{t('measurements.name')}</>}</Translation>,
  }),

  columnHelper.accessor('createdAt', {
    header: () => <Translation>{(t) => <>{t('measurements.startDate')}</>}</Translation>,
    cell: (props) => props.getValue().toLocaleDateString('de-DE'),
  }),

  columnHelper.accessor('batchCount', {
    header: () => (
      <Translation>{(t) => <>{t('fermentations.numOfAnalysis')}</>}</Translation>
    ),
    cell: (props) => props.getValue(),
  }),

  // we only show this for admin users
  columnHelper.accessor('email', {
    id: 'email',
    header: () => <Translation>{(t) => <>{t('Email')}</>}</Translation>,
  }),

  columnHelper.accessor('state', {
    header: () => (
      <Translation>
        {(t) => (
          <span className="flex justify-end w-full">{t('fermentations.actions')}</span>
        )}
      </Translation>
    ),
    cell: (props) => {
      return (
        <div className="flex gap-4 justify-end w-full">
          <ActionButtonWrapper {...props.row.original} />
        </div>
      );
    },
  }),
];
